/**
 * Saved Filter Views (AQ-646) — shared types.
 *
 * A "saved view" is a named snapshot of a page's whitelisted filter query
 * params. It is stored per-page + per-org in localStorage and can be shared as
 * a plain URL. See docs/superpowers/specs/2026-08-26-analytics-saved-filter-views-design.md.
 */

/** One saved view. `query` is a serialized query string (no leading `?`). */
export interface SavedView {
  id: string;
  name: string;
  query: string;
  createdAt: number;
}

export type SavedViewsPageKey = 'analytics' | 'aepqc-analytics' | 'qc';

/**
 * Per-page configuration — the only thing that differs between pages. A param
 * belongs to a view when its key is in `filterParamKeys` OR starts with any
 * entry in `filterParamPrefixes` (e.g. `metadata.` for QC/Analytics).
 */
export interface SavedViewsPageConfig {
  pageKey: SavedViewsPageKey;
  /** Exact param names that make up a view. */
  filterParamKeys: string[];
  /** Prefix classes captured wholesale, e.g. `['metadata.']`. */
  filterParamPrefixes: string[];
}

/** Max saved views kept per page+org (product decision, AQ-646). */
export const MAX_SAVED_VIEWS_PER_PAGE = 10;

/** Query param carrying a shared view's name so the recipient's save prompt pre-fills. */
export const SHARED_VIEW_NAME_PARAM = 'sv_name';
